/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_NextInputs */

const en_gc_guides_next = /** @type {(inputs: Gc_Guides_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your work, then go further`)
};

const zh_gc_guides_next = /** @type {(inputs: Gc_Guides_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查结果，继续探索`)
};

/**
* | output |
* | --- |
* | "Check your work, then go further" |
*
* @param {Gc_Guides_NextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_next = /** @type {((inputs?: Gc_Guides_NextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_NextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_next(inputs)
	return zh_gc_guides_next(inputs)
});
export { gc_guides_next as "gc.guides.next" }